import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CompanyPriceLabelEntityState } from '@_model/interfaces/company-price-label.model';

export interface CompanyPriceLabelState extends EntityState<CompanyPriceLabelEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<CompanyPriceLabelEntityState> = createEntityAdapter<CompanyPriceLabelEntityState>({
  selectId: o => o.idCompanyPriceLabel
});
export const initialState: CompanyPriceLabelState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const companyPriceLabelFeatureKey = 'companyPriceLabel';
